export default __webpack_public_path__ + "static/media/logo3.706b817f.png";